import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { deepCopy } from 'utils/api/deepCopy'

import { store } from './store'

export type AppState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<AppState> = (selector, equalityFn) => {
  const result = useSelector(selector, equalityFn)
  if (typeof result === 'function') {
    return result
  }
  return deepCopy(result)
}
export const createAppSelector = createSelector.withTypes<AppState>()
